import React from "react";
import Money from "components/money";
import storeCurrency from "helpers/currency";
import getImagePath from "helpers/get-image-path";
import * as styles from "./style.mod.scss";
import { Button } from "react-bootstrap";
import GreenCheckmark from "src/assets/svgs/green_checkmark.svg";
import locales from "locales";

const PrimaryCrossSellStyle = ({
  upsell,
  addVariantToCart,
  handleVariantSelect,
  selectedVariant,
  addVariant,
  type,
  variantIsAdded,
  differencePrice
}) => {
  const handleAddVariant = () => {
    if (selectedVariant?.variant?.store?.inStock) {
      (type === "eco-package" ? addVariant : addVariantToCart)(selectedVariant?.variant);
    } else {
      return;
    }
  };
  
  return (
    selectedVariant?.variant?.store && 
    <div className={`${styles.upsellVariant} ${styles.primaryCrossSell} ${selectedVariant.variant?.store?.inStock ? "" : styles.outOfStock}`}>
      {selectedVariant && (
        <>
          <img
            className={`${styles.productImage} ${selectedVariant?.imageSize === "square" && styles.squareImg}`}
            src={getImagePath(selectedVariant?.image)}
            alt={selectedVariant?.image?.alt}
          />
          <p className={styles.crossSellVariantTitle}>{selectedVariant?.title}</p>
          <div className={styles.selectedVariant}>
            <div className={styles.variantButtons}>
              {upsell?.singleVariant?.map((variant, i) => (
                <React.Fragment key={i}>
                  {variant?.variantColor?.hex &&
                    <Button
                      key={i}
                      className={`${styles.button} ${variant === selectedVariant && styles.variantIsSelected}`}
                      onClick={() => handleVariantSelect(variant)}
                      disabled={!selectedVariant.variant?.store?.inStock}
                      style={{
                        backgroundColor: variant?.variantColor?.hex,
                        backgroundSize: "cover"
                      }}
                    ></Button>}</React.Fragment>
              ))}
            </div>
            <div className={styles.priceBox} onClick={handleAddVariant}
            >
              <div className={`${styles.priceText} ${variantIsAdded && styles.variantAddedBox}`}>
                {variantIsAdded ? <span>{locales.products.added} <GreenCheckmark /></span> :
                  <span className={styles.price}>
                    <span className={styles.plus}>+</span>
                    {selectedVariant?.variant?.store?.price !== 0 ? (
                      type === "eco-package" ? <Money value={differencePrice} integer={true} /> : <Money value={type ? differencePrice : selectedVariant?.variant?.store?.price} integer={true} />
                    ) : (
                      <>0{storeCurrency()}</>
                    )}
                  </span>}
              </div>
              {!selectedVariant?.variant?.store?.inStock &&
                <p className={styles.outOfStockInfo}>
                  {locales.products.outOfStock}
                </p>
              }
            </div>
          </div>
        </>
      )}
    </div>
  );
};


export default PrimaryCrossSellStyle;
